export default __webpack_public_path__ + "static/media/tech2_2.f28b7649.png";